import { reactive } from 'vue'
import { findRateCodeList, findRoomTypeList } from '@/api/room'
import moment from 'moment'

export default function commomFunction() {
    const roomTypeList = reactive([])
    const rateCodeList = reactive([])

    const findRoomTypeAll = async () => {
        const { list } = await findRoomTypeList({ page: 1, size: 1000 })
        roomTypeList.length = 0
        roomTypeList.push(...list)
    }
    const findRateCodeAll = async () => {
        const { list } = await findRateCodeList({ page: 1, size: 1000 })
        rateCodeList.length = 0
        rateCodeList.push(...(list || []))
    }

    const enumerateDaysBetweenDates = (startDate, endDate) => {
        let daysList = [];
        const start = moment(startDate);
        const end = moment(endDate);
        const day = end.diff(start, "day");
        daysList.push(start.format("YYYY-MM-DD"));
        for (let i = 1; i <= day; i++) {
          daysList.push(start.add(1, "day").format("YYYY-MM-DD"));
        }
        return daysList;
      };
      
    findRoomTypeAll()
    findRateCodeAll()

    return {
        roomTypeList,
        rateCodeList,
        enumerateDaysBetweenDates
    }
}